export interface StageSubdivision {
  value: string;
  label: string;
}

export interface StageInfo {
  label: string;
  subdivisions: StageSubdivision[];
}

export type StageKey = keyof typeof stageData;

// ---------- Stage Data ----------
export const stageData: Record<string, StageInfo> = {
  STAGE1: {
    label: "Customer",
    subdivisions: [
      { value: "SWITCH_OFF", label: "Mobile switched off" },
      { value: "NOT_REACHABLE", label: "Mobile not reachable" },
      { value: "SPEAK_LESS_THAN_1_MIN", label: "Spoke less than 1 minute" },
      { value: "NOT_RESPECTFUL", label: "Customer did not speak respectfully" },
      { value: "KNOW_EVERYTHING", label: "Customer said: 'I know everything'" },
      { value: "OTHERS", label: "Other" }
    ]
  },

  STAGE2: {
    label: "Network",
    subdivisions: [
      { value: "I_HAVE_HEARD", label: "I have heard about this" },
      { value: "JOINED_ONCE", label: "I joined once, but didn’t continue" },
      { value: "CHEATED", label: "I did it before, and they cheated me" },
      { value: "SELLING_THINGS", label: "Is this selling products?" },
      { value: "SCAM", label: "This is a scam?" },
      { value: "CATCHING_PEOPLE_RIGHT", label: "I know how people get recruited" },
      { value: "HAS_EXPERIENCE", label: "I have experience with this" },
      { value: "OTHERS", label: "Other" }
    ]
  },

  STAGE3: {
    label: "Vestige",
    subdivisions: [
      { value: "FAMILY_TOLD", label: "Family or neighbors told me" },
      { value: "JOINED_PURCHASE_ONCE", label: "Joined but purchased once" },
      { value: "JOINED_MORE_THAN_1_YEAR", label: "Joined > 1 year" },
      { value: "DOING_VESTIGE_NOW", label: "I am doing Vestige" },
      { value: "DONT_KNOW_VESTIGE", label: "I don’t know about Vestige" },
      { value: "OTHERS", label: "Other" }
    ]
  },

  STAGE4: {
    label: "Upline",
    subdivisions: [
      { value: "WAIT_UPLINE_APPOINTMENT", label: "Waiting for upline appointment" },
      { value: "WAIT_CLIENT_APPOINTMENT", label: "Waiting for client appointment" },
      { value: "CALL_UPLINE", label: "Call with upline" },
      { value: "ZOOM_ONE_TO_ONE", label: "1:1 Zoom" },
      { value: "ONLINE_CNT_PERSONAL", label: "Online personal CNT" },
      { value: "ONLINE_CNT_COMMON", label: "Online common CNT" },
      { value: "OTHERS", label: "Other" }
    ]
  },

  STAGE5: {
    label: "Product",
    subdivisions: [
      { value: "WAIT_CLIENT_APPOINTMENT", label: "Waiting for client appointment" },
      { value: "PHONE_EXPLAIN_PRODUCT", label: "Explained on phone" },
      { value: "ZOOM_EXPLAIN_PRODUCT", label: "Explained in Zoom" },
      { value: "SEND_BROCHURE", label: "Sent brochure" },
      { value: "OTHERS", label: "Other" }
    ]
  },

  STAGE6: {
    label: "Leaders",
    subdivisions: [
      { value: "ID_CREATION", label: "ID created" },
      { value: "PRODUCT_PURCHASE", label: "Product purchased" },
      { value: "CONNECT_COMMON_NDO", label: "Connected to NDO" },
      { value: "PERSONAL_NDO_ZOOM", label: "Personal NDO Zoom" },
      { value: "REGULAR_USER", label: "Regular user" },
      { value: "CNC_USER", label: "CNC user" },
      { value: "OTHERS", label: "Other" }
    ]
  },

  STAGE7: {
    label: "Result",
    subdivisions: [
      { value: "REGULAR_SESSION", label: "Regular session attendance" },
      { value: "INTRODUCING_PEOPLE", label: "Introducing new prospects" },
      { value: "EIGHT_PERCENT", label: "Achieved 8%" },
      { value: "DIRECTOR_VESTIGE", label: "Director Level" },
      { value: "OTHERS", label: "Other" }
    ]
  }
};

